module.exports = __webpack_public_path__ + "static/media/header.f07c1c3e.svg";